import React, { useEffect, useRef, useState } from 'react';
import Loader from "react-loader-spinner";
import { X, Search } from 'react-bootstrap-icons';
import { Table, Modal, Button } from 'react-bootstrap';
import { getStaffList4Modal } from "../../BaseInfo/store/api/StaffApi";
import { translateError } from '../../store/api/CommonFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUserCheck } from '@fortawesome/free-solid-svg-icons';
const ModalSelectStaff = (props) => {
    const searchData = useRef({});
    const [resultList, setResultList] = useState([]);
    const { setPopSelectStaff, popData } = props;
    const { forAgency, forMiddleman, forPersonnel, show, onSelect, value, parentID, excludeAgency } = popData;
    const staffType = forAgency ? "نماینده" : forMiddleman ? "واسط فروش" : forPersonnel ? "پرسنل" : "تکنسین";
    const staffType_ = forAgency ? "agency" : forMiddleman ? "middleman" : forPersonnel ? "personnel" : "staff";
    const cancel = () => {
        if (onSelect)
            onSelect(null);
        setPopSelectStaff({ show: false });
    }
    const selectStaff = (item) => {
        onSelect(item);
        setPopSelectStaff({ show: false });
    }
    function searhKeyDown(e) {
        if (e.key === "Enter") {
            search();
        }
        else if (e.keyCode === 27) {
            cancel();
        }

    }
    const search = () => {
        searchData.current.Take = 5;
        if(excludeAgency)
        {
            searchData.current.IsAgency = false;
        }
        if (parentID) {
            searchData.current.ParentID = parentID;
        }
        else {
            searchData.current.ParentID = null;
        }
        getStaffList4Modal(staffType_, searchData.current, setResultList);
    }
    useEffect(() => {
        if (show) {
            searchData.current = {};
            const input = document.getElementById("inputSearchStaffName");
            input.focus();
            if (value && value !== '') {
                input.value = value;
            }
        }
    }, [show])
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faUserCheck} size='lg' />&nbsp;
                    {"انتخاب " + staffType}
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={cancel} />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <div className='row mt-0' style={{ marginLeft: "2px", marginRight: "2px" }}>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder={'کد ' + staffType} type="text" className='form-control' onChange={(e) => searchData.current.Code = e.target.value} onKeyDown={searhKeyDown} />
                    </div>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input id="inputSearchStaffName" placeholder={'نام ' + staffType} type="text" className='form-control' onChange={(e) => searchData.current.Name = e.target.value} onKeyDown={searhKeyDown} />
                    </div>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder={'موبایل ' + staffType} type="text" className='form-control' onChange={(e) => searchData.current.Mobile = e.target.value} onKeyDown={searhKeyDown} />
                    </div>
                </div>
                <div>
                    <Button className="group-Btn-large mt-2 mb-2" onClick={search}><Search size={18} />&nbsp;جستجوی {staffType}</Button>
                </div>
                <Table>
                    <thead>
                        <tr>
                            <th style={{ display: "none" }}></th>
                            <th>{"کد " + staffType}</th>
                            <th>{"نام " + staffType}</th>
                            <th>موبایل</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultList?.Error &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", color: "red" }}>{translateError(resultList.Error)}</td>
                            </tr>
                        }
                        {(resultList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center" }}>
                                    <Loader type="BallTriangle" color="#bb1370" height={27} width={27} />
                                </td>
                            </tr>
                        }
                        {resultList && !resultList.Error && Array.isArray(resultList) &&
                            resultList.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => selectStaff(item)}>
                                    <td style={{ display: "none" }}></td>
                                    <td>{item.Code}</td>
                                    <td>{item.LastName}</td>
                                    <td>{item.Mobile}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectStaff;